module.exports = __webpack_public_path__ + "img/sunder-charms.9e64b879.png";